import NO05 from '../../models/NO05';
import { STATUS_GROUPS, KONTANT_PAYMENT_METHODS, DIREKTE_ORDER_TYPES, isPlukkOrdre, hasBkCode, isReturnToSupplierBk, statusInGroup } from './no05StatusGroups';
import { filterByDate } from './no05Stats';

/** Leveringsfilter over the order table — only one can be active at a time ('' = none). */
export type DeliveryFilter = '' | 'komplett' | 'delvis';

/** Komplett levert: antall bestilt = antall levert. */
export const isKomplettLevert = (o: NO05) => o.antBestilt === o.antLevert;

/** Delvis levert: avvik mellom antall bestilt og antall levert. */
export const isDelvisLevert = (o: NO05) => o.antBestilt !== o.antLevert;

export function filterByStatus(orders: NO05[], selectedStatus: string): NO05[] {
    const group = STATUS_GROUPS.find(g => g.name === selectedStatus);
    if (!selectedStatus || selectedStatus === 'Alle ordre' || !group) return orders;
    if (group.isReturn) return orders.filter(o => o.ordreNr.startsWith('9'));
    if (group.isKontant) return orders.filter(o => KONTANT_PAYMENT_METHODS.includes(o.betalingsKode));
    if (group.isDirekte) return orders.filter(o => DIREKTE_ORDER_TYPES.includes(o.direkteFlagg));
    if (group.isPlukk) return orders.filter(o => isPlukkOrdre(o.skaff));
    if (group.isBkCode) return orders.filter(o => hasBkCode(o.bk));
    if (group.isReturnToSupplier) return orders.filter(o => isReturnToSupplierBk(o.bk));
    if (group.statuses) return orders.filter(o => !o.ordreNr.startsWith('9') && statusInGroup(group, o.status));
    return orders;
}

export function filterByDelivery(orders: NO05[], deliveryFilter: DeliveryFilter): NO05[] {
    if (deliveryFilter === 'komplett') return orders.filter(isKomplettLevert);
    if (deliveryFilter === 'delvis') return orders.filter(isDelvisLevert);
    return orders;
}

/**
 * The orders shown in the table: Ordredato box, then status card, then leveringsfilter —
 * newest first. Shared by the table and the toolbar so "Velg alle" and the Excel exports work
 * on exactly what's on screen.
 */
export function getVisibleOrders(orders: NO05[], selectedStatus: string, selectedDate: string, deliveryFilter: DeliveryFilter): NO05[] {
    const filtered = filterByDelivery(filterByStatus(filterByDate(orders, selectedDate), selectedStatus), deliveryFilter);
    // Newest first: date, then time of day (tid = HHMMSS), then order number — so today's
    // latest order is at the top (testing team / Stian).
    return filtered.slice().sort((a, b) => {
        const dateDiff = new Date(b.dato).getTime() - new Date(a.dato).getTime();
        if (dateDiff !== 0) return dateDiff;
        const timeDiff = (parseInt(b.tid, 10) || 0) - (parseInt(a.tid, 10) || 0);
        if (timeDiff !== 0) return timeDiff;
        return parseInt(b.ordreNr, 10) - parseInt(a.ordreNr, 10);
    });
}
